import React, { useContext } from 'react'
import { getMemoisedYearlyConsumption } from 'lib/calculations'
import germanMessages from './locales/de.yml'
import IntlMessageFormat from 'intl-messageformat'
import 'intl-pluralrules'
import { Consumption } from 'contexts/consumption'
import { Locale } from 'contexts/locale'
import { getFormatVolume } from 'lib/formatters'

const messages = {
  de: germanMessages
}

export function TotalConsumption() {
  const consumption = useContext(Consumption)
  const locale = useContext(Locale)
  const formatVolume = getFormatVolume(locale)
  const formatResultMessage = new IntlMessageFormat(
    messages[locale].sumResult,
    `${locale}-CH`
  )

  return (
    <p
      dangerouslySetInnerHTML={{
        __html: formatResultMessage.format({
          amount: formatVolume.format(getMemoisedYearlyConsumption(consumption))
        })
      }}
    />
  )
}
